import React, { useState } from 'react';
import TopHeader from './TopHeader';
import SubHeader from './SubHeader';
import './Header.scss'

function Header() {
	const [menuOpen, setMenuOpen] = useState(false);

	return (
		<div className="header">
			<TopHeader menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
			<SubHeader menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
		</div>
	);
}

export default Header;